import { Component, OnInit } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';

@ManageType('DashboardComponent')
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  public widgetPosition = [
    {top: 1, left: 1, height: 1, width: 1},
    {top: 1, left: 2, height: 1, width: 1},
    {top: 1, left: 3, height: 1, width: 1},
    {top: 2, left: 1, height: 2, width: 1},
    {top: 2, left: 2, height: 2, width: 1},
    {top: 2, left: 3, height: 2, width: 1}
  ];
  public widgetMovable = false;
  public widgetResizable = false;

  constructor() { }

  ngOnInit(): void {
  }

  onWidgetChange(event) {

  }
}
